import { esES, enUS } from "@mui/x-data-grid/locales";

const NO_ROWS_LABEL = {
  es: "Lo sentimos, no se encontraron registros coincidentes",
  en: "No matching records found",
};

/**
 * Resolves the DataGrid localeText pack for the app language.
 *
 * Replaces the hand-maintained Translation / TranslationEN objects the old
 * MuiTable wrapper carried: MUI X ships official, complete locale packs, so we
 * reuse those instead of keeping our own copy of every pagination/filter/export
 * string in sync. Only the empty-state label is overridden to match the
 * previous wording.
 *
 * @param language - i18n language code ("es" | "en" | ...).
 */
export const getLocaleText = (language: string) => {
  const isEs = language === "es";
  const pack = (isEs ? esES : enUS).components.MuiDataGrid.defaultProps.localeText;
  return {
    ...pack,
    noRowsLabel: isEs ? NO_ROWS_LABEL.es : NO_ROWS_LABEL.en,
  };
};
